<template>
    <div>
        <q-btn class=" mobile-hide" flat  :label="$t('search')"  icon="far fa-search" @click="show_modal = true" />

        <q-item class="desktop-hide" @click.native="show_modal = true">
            <q-item-side icon="far fa-search" />
            <q-item-main :label="$t('search')" />
        </q-item>

        <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth}">
            <q-modal-layout>
                <q-toolbar slot="header" class="desktop-hide">
                    <q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />

                    <q-toolbar-title>
                        {{ $t('search') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div :class="getClassModal">
                    <q-input class="q-pa-md" v-model="search" inverted-light color="grey-3" :after="[{icon: 'far fa-search', handler () {}}]" :placeholder="$t('search')" @keydown="clearList" style="box-shadow: none;" ref="searchbox">
                        <q-autocomplete
                            @search="searchStore"
                            autocomplete="new-password"
                            :min-characters="3"
                            :debounce="1000"
                            :separator="true"
                        />
                    </q-input>

                    <q-list v-if="hasListItens" highlight no-border :class="getClassList">
                        <q-list-header v-if="trainings.length > 0">{{ $t("training") }}</q-list-header>

                        <q-item v-for="(item, index) in trainings" :key="`trainings-${index}`" @click.native="checkSearch('course', item.id)">
                            <q-item-side icon="far fa-globe"/>

                            <q-item-main>
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>

                            </q-item-main>
                        </q-item>
                        <q-item-separator v-if="trainings.length > 0" />

                        <q-list-header v-if="trails.length > 0">{{ $t("trails") }}</q-list-header>

                        <q-item v-for="(item, index) in trails" :key="`trails-${index}`" @click.native="checkSearch('trail', item.id)">
                            <q-item-side icon="fal fa-sign"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>
                            </q-item-main>
                        </q-item>
                        <q-item-separator v-if="trails.length > 0"/>

                        <q-list-header v-if="events.length > 0">{{ $t("presential") }}</q-list-header>

                        <q-item v-for="(item, index) in events" :key="`events-${index}`" @click.native="checkSearch('presential_notification', item.id)">
                            <q-item-side icon="fal fa-users-class"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-html="item.instructor" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>
                            </q-item-main>
                        </q-item>
                        <q-item-separator v-if="events.length > 0"/>

                        <q-list-header v-if="live_classes.length > 0">{{ $t("live_classes") }}</q-list-header>

                        <q-item v-for="(item, index) in live_classes" :key="`lc-${index}`" @click.native="checkSearch('live_classes', item.id)">
                            <q-item-side icon="far fa-chalkboard-teacher"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>
                            </q-item-main>
                        </q-item>
                        <q-item-separator v-if="live_classes.length > 0"/>

                        <q-list-header v-if="library_files.length > 0">{{ $t("library") }}</q-list-header>

                        <q-item v-for="(item, index) in library_files" :key="`library_files-${index}`" @click.native="checkSearch('library', item.title_data)">
                            <q-item-side icon="fal fa-books"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>
                            </q-item-main>
                        </q-item>

                        <q-item-separator v-if="library_files.length > 0"/>

                        <q-list-header v-if="podcasts.length > 0">{{ $t("podcasts") }}</q-list-header>

                        <q-item v-for="(item, index) in podcasts" :key="`podcasts-${index}`" @click.native="checkSearch('podcast', item.id)">
                            <q-item-side icon="fal fa-podcast"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>
                            </q-item-main>
                        </q-item>

                        <q-item-separator v-if="podcasts.length > 0"/>

                        <q-list-header v-if="webinars.length > 0" >{{ $t("webinars") }}</q-list-header>

                        <q-item v-for="(item, index) in webinars" :key="`webinars-${index}`" @click.native="checkSearch('webcast', item.id)">
                            <q-item-side icon="fal fa-broadcast-tower"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                                <q-item-tile sublabel lines="3" v-html="item.description" />
                                <q-item-tile sublabel lines="3" v-if="item.tags__title">
                                    Tags:
                                    <q-chip dense color="primary" class="shadow-1" v-html="tag" v-for="(tag, index) in item.tags__title" :key="index" />
                                </q-item-tile>
                            </q-item-main>
                        </q-item>

                        <q-item-separator v-if="webinars.length > 0"/>

                        <q-list-header v-if="news.length > 0" >{{ $t("news") }}</q-list-header>

                        <q-item v-for="(item, index) in news" :key="`news-${index}`" @click.native="checkSearch('news', item.id)">
                            <q-item-side icon="fal fa-newspaper"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title" />
                            </q-item-main>
                        </q-item>

                        <q-item-separator v-if="news.length > 0"/>

                        <q-list-header v-if="faq.length > 0" >{{ $t("faq") }}</q-list-header>

                        <q-item v-for="(item, index) in faq" :key="`faq-${index}`" @click.native="checkSearch('faq', item.id)">
                            <q-item-side icon="fal fa-question-circle"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title"/>
                            </q-item-main>
                        </q-item>

                        <q-item-separator v-if="faq.length > 0"/>

                        <q-list-header v-if="messages.length > 0" >{{ $t("messages") }}</q-list-header>

                        <q-item v-for="(item, index) in messages" :key="`messages-${index}`" @click.native="checkSearch('messages', item.id)">
                            <q-item-side icon="fal fa-envelope"/>
                            <q-item-main class="cursor-pointer">
                                <q-item-tile label v-html="item.title" />
                            </q-item-main>
                        </q-item>

                        <q-item-separator v-if="messages.length > 0"/>
                    </q-list>

                    <div v-if="hasInformation" class="text-center q-my-sm">
                        <p class="q-ma-none"> {{ $t("searched_term_returned_no_results")}} </p>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <modal-news :show_modal="show_news" :id="id_news" @hideModalNews="hideModalNews" />
    </div>
</template>

<script>
import ModalNews from 'components/News'
import { mapGetters } from "vuex"
export default {
    components: {
        'modal-news': ModalNews
    },
    data() {
        return {
            search: '',
            loading_search: false,
			trainings:[],
			trails:[],
			events:[],
            library_files:[],
			podcasts:[],
			webinars:[],
			news:[],
			faq: [],
            messages:[],
            live_classes: [],
            id_news: '',
            show_news: false,
            show_modal: false
        }
    },
    computed: {
        ...mapGetters({
			access_token: 'common/access_token',
        }),

		getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '50vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '50vw'
        },

        getClassModal() {
            if(this.$q.platform.is.mobile) return "layout-padding"
            else return "layout-padding q-pa-none"
        },

        getClassList() {
            if(!this.$q.platform.is.mobile) return "liste q-mt-sm"
            else return "q-mt-sm"
        },

		hasListItens() {
			if(this.trainings.length == 0 && this.trails.length == 0 && this.events.length == 0 && this.library_files.length == 0
			   && this.podcasts.length == 0 && this.webinars.length == 0 && this.news.length == 0 && this.faq.length == 0 && this.messages.length == 0 && this.live_classes.length == 0 ) return false
			else return true
		},

		hasInformation() {
			if(this.trainings.length == 0 && this.trails.length == 0 && this.events.length == 0 && this.library_files.length == 0
				&& this.podcasts.length == 0 && this.webinars.length == 0 && this.news.length == 0 && this.faq.length == 0 && this.messages.length == 0 && this.live_classes.length == 0
				&& this.search != "" && this.loading_search == false) return true
			else return false
        },

        verifyRouteAdmin() {
            return this.$route.fullPath.includes("admin")
        },
    },
    methods: {
        searchStore(terms, done) {
			this.loading_search = true
            this.$axios.get(`global_search/search/?search=${terms}`, this.getHeader)
				.then(response => {
                    var term = `<span style="background-color: #ffff83;color: #000;font-weight: 500;">${terms}</span>`
                    var regex = new RegExp(terms,"gi");

					this.trainings = response.data.trainings.map(e => {
						return {
							id: e.id,
							title: e.code && e.title
                            ? `${e.code} - ${e.title.replace(regex, term)}`
                            : !e.code && e.title
                            ? e.title.replace(regex, term)
                            : '',
							description: e.description ? e.description.replace(regex, term) : '',
							tags__title: e.tags__title.map(e => e.replace(regex, term))
							// tags__title: e.tags__title ? e.tags__title.replace(regex, term) : ''
						}
					})

					this.trails = response.data.trails.map(e => {
						return {
							id: e.id,
							title: e.title ? e.title.replace(regex, term) : '',
                            description: e.description ? e.description.replace(regex, term) : '',
                            tags__title: e.tags__title.map(e => e.replace(regex, term))
							// tags__title: e.tags__title ? e.tags__title.replace(regex, term) : ''
						}
					})

					this.events = response.data.events.map(e => {
						return {
							id: e.id,
                            title: e.code && e.title
                            ? `${e.code} - ${e.title.replace(regex, term)}`
                            : !e.code && e.title
                            ? e.title.replace(regex, term)
                            : '',
                            description: e.description ? e.description.replace(regex, term) : '',
                            instructor: e.instructor_full_name
                            ? `${this.$t('instructor')}: ${e.instructor_full_name}` : '',
                            tags__title: e.tags__title.map(e => e.replace(regex, term))
							// tags__title: e.tags__title ? e.tags__title.replace(regex, term) : ''
						}
					})
					this.library_files = response.data.library_files.map(e => {
						return {
                            id: e.id,
                            title_data: e.title,
							title:  e.title ? e.title.replace(regex, term) : '',
                            description: e.description ? e.description.replace(regex, term) : '',
                            tags__title: e.tags__title.map(e => e.replace(regex, term))
							// tags__title:  e.tags__title ? e.tags__title.replace(regex, term) : ''
						}
					})

					this.podcasts = response.data.podcasts.map(e => {
						return {
							id: e.id,
							title: e.title ? e.title.replace(regex, term) : '',
                            description: e.description ? e.description.replace(regex, term) : '',
                            tags__title: e.tags__title.map(e => e.replace(regex, term))
							// tags__title: e.tags__title ? e.tags__title.replace(regex, term) : ''
						}
					})

					this.webinars = response.data.webinars.map(e => {
						return {
							id: e.id,
							title: e.title ? e.title.replace(regex, term) : '',
                            description: e.description ? e.description.replace(regex, term) : '',
                            tags__title: e.tags__title.map(e => e.replace(regex, term))
							// tags__title: e.tags__title ? e.tags__title.replace(regex, term) : ''
						}
                    })

                    this.live_classes = response.data.live_classes.map(e => {
						return {
							id: e.id,
                            title: e.code && e.title
                            ? `${e.code} - ${e.title.replace(regex, term)}`
                            : !e.code && e.title
                            ? e.title.replace(regex, term)
                            : '',
                            description: e.description ? e.description.replace(regex, term) : '',
                            tags__title: e.tags__title.map(e => e.replace(regex, term))
						}
					})

					this.news = response.data.news.map(e => {
						return {
							id: e.id,
							title: e.title ? e.title.replace(regex, term) : '',
						}
					})

					this.faq = response.data.faq.map(e => {
						return {
							id: e.id,
							title: e.title ? e.title.replace(regex, term) : '',
						}
					})

					this.messages = response.data.messages.map(e =>{
						return {
							id: e.id,
							title: e.title ? e.title.replace(regex, term) : '',
						}
					})

					this.loading_search = false
					done()
				})
				.catch(e => {
					console.log(e)
				})
		},

		clearList() {
			this.trainings = []
			this.trails = []
			this.events = []
			this.library_files = []
			this.podcasts = []
			this.webinars = []
			this.news = []
			this.faq = []
            this.messages = []
            this.live_classes = []
        },

        hideModalNews() {
            this.show_news = false
        },

        checkSearch(type, id) {
            if(type == 'course') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_training', params: { id: id} })
                else this.$router.push({ name: 'course', params: { id: id} })
            }
            else if(type == 'trail') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_trail', params: { id: id} })
                else this.$router.push({ name: 'trail', params: { id: id} })
            }
            else if(type == 'presential_notification') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'appointment', params: { id: id} })
                else this.$router.push({ name: 'view_presential', params: { id: id} })
            }
            else if(type == 'library') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_library', params: { id: id} })
                else this.$router.push({ name: 'library-search-name', params: { name: id} })
            }
            else if(type == 'podcast') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_podcast', params: { id: id} })
                else this.$router.push({ name: 'podcasts'})
            }
            else if(type == 'webcast') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_webcast', params: { id: id} })
                else this.$router.push({ name: 'webcast', params: { id: id} })
            }
            else if(type == 'news') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_news_edit', params: { id: id} })
                else {
                    this.show_news = true
                    this.id_news = id
                }
            }
            else if(type == 'faq') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_faq', params: { id: id} })
                else this.$router.push({ name: 'faq'})
            }
            else if(type == 'messages') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_message', params: { id: id} })
                else this.$router.push({ name: 'messages'})
            }
            else if(type == 'live_classes') {
                if(this.verifyRouteAdmin) this.$router.push({ name: 'admin_live_class', params: { id: id} })
                else this.$router.push({ name: 'live_class', params: { id: id} })
            }
        }
    },

    watch: {
        show_modal: function(show) {
            this.search = ''
            this.clearList()

            setTimeout(x => {
                this.$nextTick(() => this.$refs.searchbox.focus())
            }, 500)
        }
    },

}
</script>

<style lang="stylus" scoped>
@import '~variables';
	.liste
		height: 45vh !important
		overflow: scroll !important
		overflow-x: hidden !important

	.liste::-webkit-scrollbar-track
		border-radius: 10px
		background-color: #F5F5F5

	.liste::-webkit-scrollbar
		width: 9px
		background-color: #F5F5F5

	.liste::-webkit-scrollbar-thumb
		border-radius: 10px
		background-color: #cecece
</style>
